import React from "react";

const Breadcrumb = ({
  breadcrumb,
  bgimage,
  pageTitleColor,
  pageTitleBackgroundColor,
  businessName = '',
  websiteBackgroundColor,
  hidePageHeading = false,
}) => {
  let classInfo = 'subheader dark-overlay dark-overlay-2'
  if (businessName === "ELEVATED PIZZA CO") classInfo = 'subheader dark-overlay dark-overlay-2 special-websites'

  return (
    <div className="subheader-banner" style={{ backgroundColor: websiteBackgroundColor }}>
      <div className={classInfo} style={{ backgroundImage: `url(${bgimage})`, borderRadius: '8px' }}>
        {!hidePageHeading &&
          <div className="subheader-inner" style={{ backgroundColor: pageTitleBackgroundColor }}>
            <h1 style={{ color: pageTitleColor }}>{breadcrumb.pagename}</h1>
          </div>
        }
      </div>
    </div>
  );
};

export default Breadcrumb;
